<pbc-filter [config]="ProjektArtsFilterConfig" [filter]="projektArts.filter$ | async" (filterChange)="projektArts.filter$.next($event)"></pbc-filter>
